import { useQuery } from 'react-query';

import {
  ARTICLE_PAYWALL_PROPS_KEY,
  ArticlePaywallPropsResponse,
  getArticlePaywallProps,
} from '@utils/backend-api/articles';

export default function useArticlePaywallProps({
  articleId,
  offerCode,
  enableQuery,
}: {
  articleId: number;
  offerCode: string;
  enableQuery: boolean;
}) {
  const { data: articlePaywallProps, isLoading: isArticlePaywallPropsLoading } =
    useQuery<ArticlePaywallPropsResponse>(
      [ARTICLE_PAYWALL_PROPS_KEY, articleId],
      () => getArticlePaywallProps({ articleId, offerCode }),
      { enabled: enableQuery }
    );

  return { articlePaywallProps, isArticlePaywallPropsLoading };
}
